import { createFileRoute } from '@tanstack/react-router';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { LicensesPage } from '@/pages/licenses/licenses-page';

export const Route = createFileRoute('/licenses')({
    component: LicensesRoute,
});

// Local wrapper (NOT exported — route files export only Route). See
// routes/privacy.tsx for why the switcher mounts at the route level.
function LicensesRoute() {
    return (
        <>
            <CornerLanguageSelector />
            <LicensesPage />
        </>
    );
}
